import { Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_CONTROLS, HIDE_CONTROLS } from './property-set-form.config';
import { User } from '@miq/user';

@Pipe({
  name: 'hideControls',
  standalone: false,
})
export class HideControlsPipe implements PipeTransform {
  public hideControls = HIDE_CONTROLS;
  public defaultControls = DEFAULT_CONTROLS;
  transform(columns: any[], isStatistical: boolean, user: User): any[] {
    const isUSResearcher = Number(user?.roleId) === 1;

    if (!isUSResearcher) {
      return this.defaultControls;
    }

    return isStatistical ? columns : columns.filter(column => !this.hideControls.includes(column.field));
  }
}
